import React from 'react';
import { connect } from 'react-redux';
import { getIsLoggedIn, getLoggedInUser } from 'reducers';
import TracfoneSubNav from './TracfoneSubNav';
import AttSubNav from './AttSubNav';
import SimoSubNav from './SimoSubNav';
import SprintSubNav from './SprintSubNav';
import {
  WithUserNav,
  WithPurchaseNav,
  WithPreactivationNav,
  WithCreditNav,
} from './UserNav';
import MainNavLinks from './MainNavLinks';
import SimoDeviceNav from './SimoDeviceNav';
import QuickSubNav from './QuickSubNav';

let MainNav = ({ loggedInUser }) => {
  const userProperties = Object.keys(loggedInUser);

  if (userProperties.length === 0) {
    return null;
  }

  return (
    <div className="row MainNav">
      <div className="col-xs-6 col-sm-4 col-lg-12">
        <MainNavLinks loggedInUser={loggedInUser} />
      </div>
      <WithUserNav />
      <WithPurchaseNav />
      <WithPreactivationNav />
      <WithCreditNav />
      <SprintSubNav />
      <AttSubNav />
      <TracfoneSubNav />
      <SimoSubNav />
      <SimoDeviceNav />
      <QuickSubNav />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  loggedInUser: getLoggedInUser(state),
});

MainNav = connect(mapStateToProps)(MainNav);

export default MainNav;
